<fab-loading-spinner *ngIf="isPageLoading"></fab-loading-spinner>
<mat-dialog-content>
    <div class="modal-container">
        <h2>Are you sure you want to cancel this request?</h2>
        <div fxLayout="row" fxLayoutAlign="center" fxLayoutGap="12">
            <button mat-raised-button color="primary" (click)="close()">No</button>
            <button *ngIf="requestStatus!='REQUEST_CANCEL'" mat-raised-button color="primary" (click)="cancelRequest()">Yes</button>
            <button *ngIf="requestStatus=='REQUEST_CANCEL'" mat-raised-button color="primary" (click)="cancelApprovedRequest()">Yes</button>
        </div>
    </div>
</mat-dialog-content>
